import React from 'react';
import Button from 's2s-button';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';

const PanelItemContainer = styled.div`
  align-items: center;
  background-color: ${colorGrid.gray0};
  border-bottom: 1px solid #e5e6e8;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  height: 80px;
`;

const LeftContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

const InformationContainer = styled.div`
  display: flex;
  flex: 8;
  flex-direction: column;
  justify-content: space-around;
`;

const ActionLabel = styled.div`
  align-items : center;
  color: #4c5863;
  display: flex;
  flex: 5;
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 600;
  height: 24px;
  margin-bottom: 3px;
`;

const ActionValue = styled.div`
  align-items : center;
  color: #001221;
  display : flex;
  flex: 5;
  font-family: Open Sans;
  font-size: 16px;
  height : 24px;
  line-height: 22px;
`;

const ActionButton = styled(Button)`
  background-color: transparent;
  border: none;
  display : flex;
  height : 32px;
  justify-content : center;
  padding : 0px;
  width : 32px;


  :hover {
    background-color: ${colorGrid.gray3};
  }
`;

const PanelItem = (props) => {
  return (
    <PanelItemContainer className="panelItem" >
      <LeftContainer className="LeftContainer">
        <InformationContainer className="information" >
          <ActionLabel className="actionTitle">
            {props.actionTitle}
          </ActionLabel>
          <ActionValue className="actionValue">
            {props.actionValue}
          </ActionValue>
        </InformationContainer>
      </LeftContainer>
      {props.displayButton === false ? undefined :
        <ActionButton
          ariaLabel={"Make a call"}
          svgType="MdPhone"
          buttonType="secondary"
          buttonSize="small"
          svgFill="#243991"
          cbClick={props.cbClick}
        />
      }
    </PanelItemContainer>
  );
};

PanelItem.propTypes = {
  actionTitle: PropTypes.string,
  actionValue: PropTypes.string,
  cbClick: PropTypes.func,
  displayButton : PropTypes.bool,
};

PanelItem.defaultProps = {
  actionTitle: undefined,
  actionValue: undefined,
  cbClick: () => { console.log("cbClick is not defined in s2s-panel-item"); },
  displayButton : true
};

export default PanelItem;

